import React from "react";
import Grid from '@mui/material/Grid2';

// size presets
const xl = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12};
const lg = { xs: 12, sm: 12, md: 6,  lg: 6,  xl: 6 };
const md = { xs: 12, sm: 12, md: 4,  lg: 4,  xl: 4 };
const sm = { xs: 12, sm: 12, md: 6,  lg: 3,  xl: 3 };
const xs = { xs: 12, sm: 12, md: 2,  lg: 2,  xl: 2 };

const xlmd= { xs: 12, sm: 12, md:  8, lg:  8, xl:  8};
const xlsm= { xs: 12, sm: 12, md:  9, lg:  9, xl:  9};
const xlxs= { xs: 12, sm: 12, md: 10, lg: 10, xl: 10};


// alignment styles
const alignStyles = {
    left:   { display: "flex", justifyContent: "flex-start", alignItems: "center" },
    center: { display: "flex", justifyContent: "center",     alignItems: "center" },
    right:  { display: "flex", justifyContent: "flex-end",   alignItems: "center" },
};

// vertical alignment styles
const valignStyles = {
    top:    { display: "flex", alignItems: "flex-start" },
    middle: { display: "flex", alignItems: "center" },
    bottom: { display: "flex", alignItems: "flex-end" },
};

export function CxGrid({ size, align, valign, sx, children, ...props }) {
    const gridSize = { xl, xlxs, xlsm, xlmd, lg, md, sm, xs }[size] || xl;
    const sxAlign = align ? alignStyles[align] || {} : {};
    const sxValign = valign ? valignStyles[valign] || {} : {};

    return (
        <Grid size={gridSize} sx={{ ...sxAlign, ...sxValign, ...sx }} {...props}>
            {children}
        </Grid>
    );
}